<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

    <br>
    <fg-input label="Affiliate">
      <el-select class="removeReadonly" v-model="affiliateId" filterable placeholder="Select">
        <el-option
          v-for="affiliate in $store.getters.affiliates.filter(a => !a.archived)"
          :key="affiliate.id"
          :label="affiliate.firstName + ' ' + affiliate.lastName + ($store.getters.companySelected==0 ?
                                    ' ('+ $store.getters.getCompanyName(affiliate.affiliateCompanyId) + ')' : '')"
          :value="affiliate.id">
        </el-option>
      </el-select>
    </fg-input>

    <fg-input type="number"
              label="Amount"
              placeholder="Amount"
              v-model="amount"/>

    <fg-input type="textarea"
              autosize
              label="Payout Note"
              placeholder="Note"
              v-model="note"/>

    <span slot="footer" class="dialog-footer">
      <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
      <button class="btn btn-success" @click="savePayout()">Save</button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'Payout-Modal',
  computed: {
    mode () {
      return this.$store.state.modal.mode
    },
    title () {
      return this.mode + ' Payout'
    },
    visible () {
      return this.$store.getters.modal.current == 'Payout'
    },
    payout () {
      return this.$store.state.modal.object || {}
    },
    affiliateId: {
      get ()    { return  this.payout.affiliateId },
      set (affiliateId) { this.payout.affiliateId = affiliateId}
    },
    amount: {
      get () { /* console.log('getting payout amount from payout modal');*/ return this.payout.amount },
      set (amount)   { console.log('setting payout amount from payout modal'); this.payout.amount = Number(amount)}
    },
    note: {
      get () { return this.payout.note },
      set (note)    { this.payout.note = note }
    }
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
    },
    async savePayout() {
      //console.log('savePayout: ', typeof this.payout.amount)
      this.payout.affiliateAccountId = this.$store.getters.affiliatesJson[this.affiliateId].affiliateAccountId
      this.payout.type = this.$store.getters.Payout._type.MANUAL.value
      const res = await this.$store.dispatch(this.mode=='Edit'?'updateRestObject':'createRestObject', this.payout)
      if (res.errors) {
          if (!res.errors[0] || typeof res.errors[0] != 'string' || !res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else { this.$notify({ successMessage: 'Saved!'})
             this.closeModal()
      }
    }
  }
}
</script>

<style>

</style>